import { NOOP } from '@fedsim/helpers'
import { useForm } from 'react-hook-form'
import { getDefaultValues } from './helpers'
import { FormUI } from './form-ui'

export const UpdateItemForm = ({
  onComplete = NOOP,
  onSubmit = NOOP,
  onReset = NOOP,
  defaultValues = {},
  submitLabel = 'Submit',
  Form = {}
}) => {
  const methods = useForm({ defaultValues })
  const { handleSubmit, control } = methods

  const submitHandler = newModel => {
    const model = Object.assign({}, getDefaultValues(Form), newModel)

    onSubmit(model)
    onComplete(model?.id)
  }

  return (
    <FormUI
      submitLabel={submitLabel}
      onSubmit={handleSubmit(submitHandler)}
      onReset={onReset}
      control={control}
      Form={Form}
    />
  )
}

export const UpdateForm = ({
  Form = {},
  onComplete = NOOP,
  onSubmit = NOOP,
  defaultValues = {},
  onReset = NOOP,
  submitLabel = null
}) => {
  if (!defaultValues) return 'No Item Found with that id'

  return (
    <UpdateItemForm
      onSubmit={onSubmit}
      onComplete={onComplete}
      onReset={onReset}
      defaultValues={defaultValues}
      Form={Form}
      submitLabel={submitLabel}
    />
  )
}

export default UpdateForm
